import React, { useState, memo } from 'react';
import '@xyflow/react/dist/style.css';
import { Handle, Position, NodeProps } from '@xyflow/react';
const FlowNode = ({
  data
}: NodeProps) => {
  const [isHovered, setIsHovered] = useState(false);
  const status = data.status || 'default'; // default, active, completed, warning
  const getStatusColor = () => {
    switch (status) {
      case 'active':
        return 'bg-blue-400';
      case 'completed':
        return 'bg-green-400';
      case 'warning':
        return 'bg-yellow-400';
      default:
        return 'bg-gray-400';
    }
  };
  return <div className={`px-4 py-3 rounded-md backdrop-blur-sm bg-white/10 border border-white/20 w-[200px] transition-all duration-200 ${isHovered ? 'scale-105 bg-white/15' : ''}`} style={{
    boxShadow: isHovered ? '0 0 15px rgba(255, 255, 255, 0.3), 0 0 5px rgba(120, 180, 255, 0.5)' : '0 0 5px rgba(255, 255, 255, 0.1)'
  }} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} data-id="element-7">
      {/* Top handle - default target */}
      <Handle type="target" position={Position.Top} id="top" // Add explicit ID
    className="w-2 h-2 !bg-blue-400 ring-2 ring-white/30 ring-opacity-50 transition-all duration-200 opacity-0" style={{
      top: 0,
      transform: isHovered ? 'scale(1.2)' : 'scale(1)'
    }} data-id="element-8" />
      
      {/* Left handle - for dashed lines */}
      <Handle type="target" position={Position.Left} id="left" className="w-2 h-2 !bg-blue-400 ring-2 ring-white/30 ring-opacity-50 transition-all duration-200 opacity-0" style={{
      left: 0,
      transform: isHovered ? 'scale(1.2)' : 'scale(1)'
    }} data-id="element-9" />
      
      {/* Right handle for source - for dashed lines */}
      <Handle type="source" position={Position.Right} id="right" className="w-2 h-2 !bg-blue-400 ring-2 ring-white/30 ring-opacity-50 transition-all duration-200 opacity-0" style={{
      right: 0,
      transform: isHovered ? 'scale(1.2)' : 'scale(1)'
    }} data-id="element-10" />
      
      {/* Right handle for target - special case for ex-2 edge */}
      <Handle type="target" position={Position.Right} id="right-target" className="w-2 h-2 !bg-blue-400 ring-2 ring-white/30 ring-opacity-50 transition-all duration-200 opacity-0" style={{
      right: 0,
      top: '60%',
      // Offset it slightly so it doesn't overlap with the source handle
      transform: isHovered ? 'scale(1.2)' : 'scale(1)'
    }} data-id="element-11" />
      
      <div className="flex items-center" data-id="element-12">
        <div className={`w-2 h-2 rounded-full mr-2 ${getStatusColor()}`} data-id="element-13"></div>
        <div className="text-sm font-medium text-white" data-id="element-14">{data.label}</div>
      </div>
      
      {/* Bottom handle - default source */}
      <Handle type="source" position={Position.Bottom} id="bottom" // Add explicit ID
    className="w-2 h-2 !bg-blue-400 ring-2 ring-white/30 ring-opacity-50 transition-all duration-200 opacity-0" style={{
      bottom: 0,
      transform: isHovered ? 'scale(1.2)' : 'scale(1)'
    }} data-id="element-15" />
    </div>;
};
export default memo(FlowNode);